<template>
  <v-row justify="center">
    <v-dialog v-model="uploadDialogMessage" persistent max-width="480">
      <v-card>
        <v-card-title>
          {{ uploadDialogMessageTitle }}
        </v-card-title>
        <v-card-text class="py-4">
          <p>
            ดาวน์โหลดไฟล์ข้อมูล
            <a
              :href="downloadFileImportDataUrl"
              :download="downloadFileImportDataName"
            >
              {{ downloadFileImportDataName }}
            </a>
          </p>
        </v-card-text>
        <v-card-actions class="px-6 pb-5">
          <v-btn color="primary" @click="onClose">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    uploadDialogMessage: {
      type: Boolean,
      default: false
    },
    uploadDialogMessageTitle: {
      type: String,
      default: 'นำเข้าข้อมูลไม่สำเร็จ'
    },
    downloadFileImportDataUrl: {
      type: String,
      required: true
    },
    downloadFileImportDataName: {
      type: String,
      required: true
    }
  },
  methods: {
    onClose() {
      this.$emit('onClose')
    }
  }
}
</script>
